import {Component, OnInit} from '@angular/core';
import {FirebaseService} from '../../../service/firebase/firebase.service';
import {BundeslandFilterService} from '../../../service/bundeslandFilter/bundesland-filter.service';
import {Unwetter} from '../../../model/unwetter/unwetter';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {Bundesland, BundesLandName} from '../../../model/component/bundesland';
import {zip} from 'rxjs';

@Component({
  selector: 'app-unwetter',
  templateUrl: './unwetter.component.html',
  styleUrls: ['./unwetter.component.css']
})
export class UnwetterComponent implements OnInit {

  isLoading = true;
  selectedIndex = 0;
  selectedBundesland: string;
  bundeslaenderTabs: string[] = [];
  unwetterBundeslandVorhersagen: Unwetter[] = [];
  unwetterLandkreisVorhersagen: Unwetter[] = [];

  constructor(private firebaseService: FirebaseService,
              private bundeslandFilterService: BundeslandFilterService) {
  }

  ngOnInit(): void {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
    this.bundeslandFilterService.onFilterUpdated.subscribe(bundeslaender => {
      this.updateData(bundeslaender);
    });
    this.updateData(this.bundeslandFilterService.getSelectedBundesLaender());
  }

  onTabChange($event: MatTabChangeEvent): void {
    this.selectedBundesland = $event.tab.textLabel;
    this.selectedIndex = $event.index;
  }

  public getUnwetterBundeslandFor(bundesland: string): Unwetter | undefined {
    return this.unwetterBundeslandVorhersagen.find(unwetter => unwetter.ort.bundesland === bundesland);
  }

  public getUnwetterLandkreisFor(bundesland: string): Unwetter[] {
    return this.unwetterLandkreisVorhersagen.filter(unwetter => unwetter.ort.bundesland === bundesland);
  }

  private updateData(bundeslaender: Bundesland[]): void {
    this.isLoading = true;
    this.unwetterBundeslandVorhersagen = [];

    if (this.bundeslandFilterService.hasDeutschlandFilterActive()) {
      this.bundeslaenderTabs = Object.values(BundesLandName);
    } else {
      this.bundeslaenderTabs = bundeslaender.map(bundesland => bundesland.name);
    }

    this.selectedBundesland = this.bundeslaenderTabs.includes(this.selectedBundesland)
      ? this.selectedBundesland : this.bundeslaenderTabs[0];
    this.selectedIndex = this.bundeslaenderTabs.findIndex(tab => tab === this.selectedBundesland);

    //TODO: Workaround muss eigentlich serverseitig weg; anstatt Brandenburg_an_der_Havel nur Brandenburg
    this.bundeslaenderTabs = this.bundeslaenderTabs.map(bt => bt.replace('Brandenburg', 'Brandenburg_an_der_Havel'));

    zip(this.firebaseService.getUnwetterBundesland(this.bundeslaenderTabs),
      this.firebaseService.getUnwetterLandkreis(this.bundeslaenderTabs))
      .subscribe(([unwetterBundesland, unwetterLandkreis]) => {
        this.unwetterBundeslandVorhersagen = this.sortUnwetterByStufen(unwetterBundesland);
        this.unwetterLandkreisVorhersagen = this.sortUnwetterByStufen(unwetterLandkreis);
        this.isLoading = false;
      });


  }

  private sortUnwetterByStufen(unwetterVorhersagen: Unwetter[]) {
    return unwetterVorhersagen.sort((u1, u2) => {
      if (u1.zusammenfassung.hoechsteStufe > u2.zusammenfassung.hoechsteStufe) {
        return -1;
      }
      if (u1.zusammenfassung.hoechsteStufe < u2.zusammenfassung.hoechsteStufe) {
        return 1;
      }
      return 0;
    });
  }
}
